/**
 * ObjectField React component
 * 
 * @author    Maurizio Tidei, Jens Gruschel
 * @copyright © 2018 contexagon GmbH
 */


// React
import React from 'react';
import PropTypes from 'prop-types';

// Material UI components
import Tooltip from '@material-ui/core/Tooltip';

// application components
import ObjectTextField from "./ObjectTextField";
import ObjectNumberField from "./ObjectNumberField";
import ObjectPasswordField from "./ObjectPasswordField";
import ObjectDateField from "./ObjectDateField";
import ObjectTimeField from "./ObjectTimeField";
import ObjectDateTimeField from "./ObjectDateTimeField";
import ObjectSelectField from "./ObjectSelectField";
import ObjectCheckboxField from "./ObjectCheckboxField";
import ObjectTextArrayField from "./ObjectTextArrayField";
import ObjectColorField from "./ObjectColorField";
import ObjectCodeField from "./ObjectCodeField";
import ObjectJsonField from "./ObjectJsonField";
import ObjectLabelField from "./ObjectLabelField";
import ObjectSequenceField from "./ObjectSequenceField";
import ObjectCommandField from "./ObjectCommandField";
import ObjectURLField from "./ObjectURLField";
import ObjectMediaField from "./ObjectMediaField";
import ObjectReferenceField from "./ObjectReferenceField";
import ObjectElementField from "./ObjectElementField";
import ObjectMarkdownField from "./ObjectMarkdownField";
import ObjectIframeField from "./ObjectIframeField";


// define components for different field types
const fieldComponents = {
    bool: ObjectCheckboxField,
    checkbox: ObjectCheckboxField,
    code: ObjectCodeField,
    color: ObjectColorField,
    command: ObjectCommandField,
    composition: ObjectReferenceField,
    date: ObjectDateField,
    datetime: ObjectDateTimeField,
    element: ObjectElementField,
    float: ObjectNumberField,
    iframe: ObjectIframeField, // TODO: better remove this field type and solve CBox preview differently
    int: ObjectNumberField,
    label: ObjectLabelField,
    markdown: ObjectMarkdownField,
    mediaurl: ObjectURLField,
    medialist: ObjectMediaField,
    number: ObjectNumberField,
    password: ObjectPasswordField,
    reference: ObjectReferenceField,
    select: ObjectSelectField,
    sequence: ObjectSequenceField,
    text: ObjectTextField,
    textarray: ObjectTextArrayField,
    time: ObjectTimeField,
    typedefinition: ObjectJsonField
};


/**
 * ObjectField is a React component representing a single object field
 *
 * @author Maurizio Tidei, Jens Gruschel
 */
export class ObjectField extends React.Component {

    render() {

        const fieldProps = {
            objectId: this.props.objectId,
            fieldDef: this.props.fieldDef,
            scope: this.props.scope,
            readOnly: this.props.readOnly,
            value: this.props.value,
            suffix: this.props.suffix,
            onObjectValueChange: this.props.onObjectValueChange
        };

        const FieldElement = fieldComponents[this.props.fieldDef.type] || ObjectTextField;

        if (this.props.fieldDef.tooltip) {
            return <Tooltip title={this.props.fieldDef.tooltip}>
                <div><FieldElement {...fieldProps} /></div>
            </Tooltip>;
        }
        else {
            return <FieldElement {...fieldProps} />;
        }
    }
}

ObjectField.propTypes = {
    onObjectValueChange: PropTypes.func.isRequired,
    fieldDef: PropTypes.object.isRequired,
    objectId: PropTypes.string,
    readOnly: PropTypes.bool,
    value: PropTypes.any
};

export default ObjectField;